import React from 'react';

export default function (props) {
  return (
    <svg
      width="85"
      height="29"
      viewBox="0 0 85 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ ...props.style }}
      {...props}
    >
      <g clipPath="url(#clip0_63_402)">
        <path
          d="M40.1506 20.5107C36.6925 20.5107 33.8944 17.7126 33.8944 14.2545C33.8944 10.7964 36.6925 7.99829 40.1506 7.99829C43.6087 7.99829 46.4068 10.7964 46.4068 14.2545C46.4068 17.7126 43.5823 20.5107 40.1506 20.5107ZM40.1506 10.7172C38.1708 10.7172 36.587 12.3275 36.587 14.2809C36.587 16.2343 38.1972 17.8446 40.1506 17.8446C42.104 17.8446 43.7143 16.2343 43.7143 14.2809C43.7143 12.3275 42.104 10.7172 40.1506 10.7172Z"
          fill="white"
        />
        <path
          d="M45.0343 15.6274C44.2951 15.6274 43.688 15.0203 43.688 14.2811V14.2547V4.0389C43.688 3.29977 44.2951 2.69263 45.0343 2.69263C45.7734 2.69263 46.3805 3.29977 46.3805 4.0389V14.2811C46.4069 15.0203 45.7998 15.6274 45.0607 15.6538C45.0607 15.6274 45.0607 15.6274 45.0343 15.6274Z"
          fill="#0096D8"
        />
        <path
          d="M40.1506 20.5107C36.6925 20.5107 33.8944 17.7126 33.8944 14.2545C33.8944 10.7964 36.6925 7.99829 40.1506 7.99829C43.6087 7.99829 46.4068 10.7964 46.4068 14.2545C46.4068 17.7126 43.5823 20.5107 40.1506 20.5107ZM40.1506 10.7172C38.1708 10.7172 36.587 12.3275 36.587 14.2809C36.587 16.2343 38.1972 17.8446 40.1506 17.8446C42.104 17.8446 43.7143 16.2343 43.7143 14.2809C43.7143 12.3275 42.104 10.7172 40.1506 10.7172Z"
          fill="#0096D8"
        />
        <mask
          id="mask0_63_402"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="33"
          y="7"
          width="14"
          height="14"
        >
          <path
            d="M40.1506 20.5107C36.6925 20.5107 33.8944 17.7126 33.8944 14.2545C33.8944 10.7964 36.6925 7.99829 40.1506 7.99829C43.6087 7.99829 46.4068 10.7964 46.4068 14.2545C46.4068 17.7126 43.5823 20.5107 40.1506 20.5107ZM40.1506 10.7172C38.1708 10.7172 36.587 12.3275 36.587 14.2809C36.587 16.2343 38.1972 17.8446 40.1506 17.8446C42.104 17.8446 43.7143 16.2343 43.7143 14.2809C43.7143 12.3275 42.104 10.7172 40.1506 10.7172Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_63_402)">
          <path
            opacity="0.75"
            d="M43.6879 7.15381H41.0217V14.2811H43.6879V7.15381Z"
            fill="url(#paint0_linear_63_402)"
          />
        </g>
        <path
          d="M58.8664 20.5111C58.1273 20.5111 57.5201 19.904 57.5201 19.1649V14.2813C57.5201 13.5422 58.1273 12.9351 58.8664 12.9351C59.6055 12.9351 60.2127 13.5422 60.2127 14.2813V19.1913C60.2127 19.9304 59.6055 20.5111 58.8664 20.5111Z"
          fill="#0096D8"
        />
        <path
          d="M53.9564 20.5107C50.4983 20.5107 47.7002 17.7126 47.7002 14.2545C47.7002 10.7964 50.4983 7.99829 53.9564 7.99829C57.4145 7.99829 60.2126 10.7964 60.2126 14.2545C60.2126 17.7126 57.4145 20.5107 53.9564 20.5107ZM53.9564 10.7172C51.9766 10.7172 50.3927 12.3275 50.3927 14.2809C50.3927 16.2343 52.003 17.8446 53.9564 17.8446C55.9362 17.8446 57.5201 16.2343 57.5201 14.2809C57.5201 12.3275 55.9362 10.7172 53.9564 10.7172Z"
          fill="#0096D8"
        />
        <mask
          id="mask1_63_402"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="47"
          y="7"
          width="14"
          height="14"
        >
          <path
            d="M53.9564 20.5107C50.4983 20.5107 47.7002 17.7126 47.7002 14.2545C47.7002 10.7964 50.4983 7.99829 53.9564 7.99829C57.4145 7.99829 60.2126 10.7964 60.2126 14.2545C60.2126 17.7126 57.4145 20.5107 53.9564 20.5107ZM53.9564 10.7172C51.9766 10.7172 50.3927 12.3275 50.3927 14.2809C50.3927 16.2343 52.003 17.8446 53.9564 17.8446C55.9362 17.8446 57.5201 16.2343 57.5201 14.2809C57.5201 12.3275 55.9362 10.7172 53.9564 10.7172Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask1_63_402)">
          <path opacity="0.75" d="M57.52 13.9907H54.8539V21.1181H57.52V13.9907Z" fill="url(#paint1_linear_63_402)" />
        </g>
        <path
          d="M63.3277 20.5634C62.5885 20.5634 61.9814 19.9563 61.9814 19.2172V14.3072C61.9814 10.8492 64.7795 8.05103 68.2376 8.05103C68.9767 8.05103 69.5839 8.65817 69.5839 9.3973C69.5839 10.1364 68.9767 10.7436 68.2376 10.7436C66.2578 10.7436 64.6739 12.3538 64.6739 14.3072V19.2172C64.6739 19.9563 64.0668 20.5634 63.3277 20.5634Z"
          fill="#0096D8"
        />
        <path
          d="M80.5916 20.5111C79.8525 20.5111 79.2454 19.904 79.2454 19.1649V14.2813C79.2454 13.5422 79.8525 12.9351 80.5916 12.9351C81.3308 12.9351 81.9379 13.5422 81.9379 14.2813V19.1913C81.9115 19.9304 81.3308 20.5111 80.5916 20.5111Z"
          fill="#0096D8"
        />
        <path
          d="M75.6817 20.5107C72.2236 20.5107 69.4255 17.7126 69.4255 14.2545C69.4255 10.7964 72.2236 7.99829 75.6817 7.99829C79.1398 7.99829 81.9379 10.7964 81.9379 14.2545C81.9379 17.7126 79.1134 20.5107 75.6817 20.5107ZM75.6817 10.7172C73.7019 10.7172 72.118 12.3275 72.118 14.2809C72.118 16.2343 73.7283 17.8446 75.6817 17.8446C77.6615 17.8446 79.2454 16.2343 79.2454 14.2809C79.2454 12.3275 77.6351 10.7172 75.6817 10.7172Z"
          fill="#0096D8"
        />
        <mask
          id="mask2_63_402"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="69"
          y="7"
          width="13"
          height="14"
        >
          <path
            d="M75.6817 20.5107C72.2236 20.5107 69.4255 17.7126 69.4255 14.2545C69.4255 10.7964 72.2236 7.99829 75.6817 7.99829C79.1398 7.99829 81.9379 10.7964 81.9379 14.2545C81.9379 17.7126 79.1134 20.5107 75.6817 20.5107ZM75.6817 10.7172C73.7019 10.7172 72.118 12.3275 72.118 14.2809C72.118 16.2343 73.7283 17.8446 75.6817 17.8446C77.6615 17.8446 79.2454 16.2343 79.2454 14.2809C79.2454 12.3275 77.6351 10.7172 75.6817 10.7172Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask2_63_402)">
          <path
            opacity="0.75"
            d="M79.2453 14.1489H76.5792V21.2763H79.2453V14.1489Z"
            fill="url(#paint2_linear_63_402)"
          />
        </g>
        <path
          d="M12.0373 20.5107H6.22981C2.79814 20.5107 0 17.7126 0 14.2809C0 13.8585 0.052795 13.4362 0.131988 13.0402C0.791925 10.0573 3.43168 7.97188 6.46739 8.02468H7.60248C7.84006 8.02468 8.05124 7.8135 8.05124 7.57592V6.44082C7.97205 3.43151 10.0575 0.791756 13.014 0.131818C16.3929 -0.554518 19.6925 1.61008 20.3789 4.98896C20.4581 5.41132 20.5109 5.80728 20.5109 6.22964V12.0371C20.5109 16.7095 16.7096 20.5107 12.0373 20.5107ZM6.46739 10.7172C4.72515 10.6908 3.1677 11.8523 2.74534 13.5418C2.53416 14.5977 2.79814 15.7064 3.48447 16.5247C4.17081 17.343 5.17391 17.8446 6.22981 17.8446H12.0373C15.2314 17.8446 17.8183 15.2576 17.8447 12.0371V6.22964C17.8447 5.17374 17.3696 4.14424 16.5248 3.4843C15.7065 2.79797 14.5978 2.50759 13.5419 2.74517C11.8525 3.16753 10.6646 4.69859 10.7174 6.46722V7.60231C10.7174 9.31815 9.31832 10.7172 7.60248 10.7172H6.46739Z"
          fill="#0096D8"
        />
        <mask
          id="mask3_63_402"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="21"
          height="21"
        >
          <path
            d="M12.0373 20.5107H6.22981C2.79814 20.5107 0 17.7126 0 14.2809C0 13.8585 0.052795 13.4362 0.131988 13.0402C0.791925 10.0573 3.43168 7.97188 6.46739 8.02468H7.60248C7.84006 8.02468 8.05124 7.8135 8.05124 7.57592V6.44082C7.97205 3.43151 10.0575 0.791756 13.014 0.131818C16.3929 -0.554518 19.6925 1.61008 20.3789 4.98896C20.4581 5.41132 20.5109 5.80728 20.5109 6.22964V12.0371C20.5109 16.7095 16.7096 20.5107 12.0373 20.5107ZM6.46739 10.7172C4.72515 10.6908 3.1677 11.8523 2.74534 13.5418C2.53416 14.5977 2.79814 15.7064 3.48447 16.5247C4.17081 17.343 5.17391 17.8446 6.22981 17.8446H12.0373C15.2314 17.8446 17.8183 15.2576 17.8447 12.0371V6.22964C17.8447 4.24983 16.2609 2.66598 14.2811 2.66598C14.0435 2.66598 13.7795 2.69238 13.5419 2.74517C11.8525 3.16753 10.6646 4.69859 10.7174 6.46722V7.60231C10.7174 9.31815 9.31832 10.7172 7.60248 10.7172H6.46739Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask3_63_402)">
          <path
            opacity="0.75"
            d="M20.9332 10.7173H17.3695V13.3834H20.9332V10.7173Z"
            fill="url(#paint3_linear_63_402)"
          />
        </g>
        <path
          d="M27.1367 10.3212C25.9488 8.86938 24.1802 8.02466 22.306 8.02466H16.4985C11.8261 8.02466 8.0249 11.8259 8.0249 16.4983V17.8445H10.6911V16.4983C10.6911 13.3042 13.278 10.7172 16.4985 10.6908H22.306C24.2858 10.6908 25.8696 12.2747 25.8696 14.2545C25.8696 14.492 25.8432 14.756 25.7904 14.9936C25.3681 16.683 23.837 17.8709 22.0684 17.8181H20.9333C19.2174 17.8181 17.8184 19.2172 17.8184 20.933V22.0681C17.8448 23.8104 16.6833 25.3678 14.9938 25.7902C13.9379 26.0278 12.8292 25.7374 12.0109 25.0511C11.1926 24.3647 10.6911 23.3616 10.6911 22.3057V20.5107H8.0249V22.3057C8.0249 25.7638 10.823 28.5619 14.2547 28.5619C14.6771 28.5619 15.0994 28.5091 15.4954 28.4299C18.4519 27.77 20.5373 25.1302 20.4845 22.0945V20.9594C20.4845 20.7219 20.6957 20.5107 20.9333 20.5107H22.0684C25.1041 20.5635 27.7438 18.4781 28.4038 15.5216C28.7997 13.6737 28.3246 11.7731 27.1367 10.3212Z"
          fill="#51B8E5"
        />
        <mask
          id="mask4_63_402"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="8"
          y="8"
          width="21"
          height="21"
        >
          <path
            d="M27.1367 10.3212C25.9488 8.86938 24.1802 8.02466 22.306 8.02466H16.4985C11.8261 8.02466 8.0249 11.8259 8.0249 16.4983V17.8445H10.6911V16.4983C10.6911 13.3042 13.278 10.7172 16.4985 10.6908H22.306C24.2858 10.6908 25.8696 12.2747 25.8696 14.2545C25.8696 14.492 25.8432 14.756 25.7904 14.9936C25.3681 16.683 23.837 17.8709 22.0684 17.8181H20.9333C19.2174 17.8181 17.8184 19.2172 17.8184 20.933V22.0681C17.8448 23.8104 16.6833 25.3678 14.9938 25.7902C13.9379 26.0278 12.8292 25.7374 12.0109 25.0511C11.1926 24.3647 10.6911 23.3616 10.6911 22.3057V20.5107H8.0249V22.3057C8.0249 25.7638 10.823 28.5619 14.2547 28.5619C14.6771 28.5619 15.0994 28.5091 15.4954 28.4299C18.4519 27.77 20.5373 25.1302 20.4845 22.0945V20.9594C20.4845 20.7219 20.6957 20.5107 20.9333 20.5107H22.0684C25.1041 20.5635 27.7438 18.4781 28.4038 15.5216C28.7997 13.6737 28.3246 11.7731 27.1367 10.3212Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask4_63_402)">
          <path
            opacity="0.75"
            d="M11.2188 20.5107H7.65515V23.1769H11.2188V20.5107Z"
            fill="url(#paint4_linear_63_402)"
          />
        </g>
        <path
          d="M65.8354 23.4676H64.1724V23.9427H65.8354C66.5217 23.9427 67.0761 24.4707 67.0761 25.1306C67.0761 25.7906 66.5217 26.3185 65.8354 26.3185H64.6739V25.3682H65.6242L65.2811 25.7114L65.6242 26.0545L66.5745 25.157L65.6242 24.2595L65.2811 24.6027L65.6242 24.9195H64.1724V26.8201H65.8354C66.7857 26.8201 67.5512 26.0809 67.5512 25.157C67.5512 24.2331 66.7857 23.4676 65.8354 23.4676ZM74.3354 25.553C74.1506 26.0018 73.7019 26.3185 73.1739 26.3185C72.4876 26.3185 71.9068 25.7906 71.9068 25.1042C71.9068 24.4179 72.4612 23.89 73.1739 23.89C73.7019 23.89 74.177 24.2067 74.3354 24.6555H74.8634C74.6522 23.9427 73.9922 23.4148 73.1739 23.4148C72.1972 23.4148 71.4317 24.1803 71.4317 25.1042C71.4317 26.0281 72.2236 26.7937 73.1739 26.7937C73.9922 26.7937 74.6786 26.2657 74.8634 25.553H74.3354ZM69.5047 23.9163C68.8183 23.9163 68.2376 24.4443 68.2376 25.1306C68.2376 25.817 68.7919 26.3449 69.5047 26.3449C70.2174 26.3449 70.7717 25.817 70.7717 25.1306C70.7717 24.4443 70.191 23.9163 69.5047 23.9163ZM69.5047 26.7937C68.5279 26.7937 67.7624 26.0281 67.7624 25.1042C67.7624 24.1803 68.5543 23.4148 69.5047 23.4148C70.4814 23.4148 71.2469 24.1803 71.2469 25.1042C71.2469 26.0545 70.455 26.7937 69.5047 26.7937Z"
          fill="#131E29"
        />
        <path
          d="M81.7003 25.1304C81.7003 25.7903 81.1459 26.3446 80.4332 26.3446C79.7469 26.3446 79.1661 25.8167 79.1661 25.1304C79.1661 24.444 79.7205 23.9161 80.4332 23.9161C81.1459 23.9161 81.7003 24.4704 81.7003 25.1304ZM82.2018 25.1304C82.2018 24.2064 81.4099 23.4409 80.4596 23.4409C79.4829 23.4409 78.7174 24.2064 78.7174 25.1304C78.7174 26.0543 79.5093 26.8198 80.4596 26.8198C81.4099 26.7934 82.2018 26.0543 82.2018 25.1304ZM82.017 26.767V26.5558H81.9642L81.9114 26.7142L81.8587 26.5558H81.8059V26.767H81.8323V26.6086L81.8851 26.767H81.9114L81.9642 26.6086V26.767H82.017ZM81.7003 26.767V26.6086H81.7795V26.5822H81.5947V26.6086H81.6739V26.767H81.7003ZM78.5326 25.0512C78.5326 25.0776 78.5326 25.104 78.5326 25.1304C78.5326 26.0543 77.7406 26.8198 76.7903 26.8198C75.8136 26.8198 75.0481 26.0543 75.0481 25.1304C75.0481 24.2064 75.84 23.4409 76.7903 23.4409C77.4503 23.4409 78.031 23.7841 78.3478 24.3384C78.4006 24.444 78.4534 24.5496 78.4798 24.6816H77.9518C77.9254 24.6288 77.9254 24.6024 77.899 24.5496C77.6879 24.1537 77.2655 23.8897 76.7903 23.8897C76.104 23.8897 75.5233 24.4176 75.5233 25.104C75.5233 25.7903 76.0776 26.3182 76.7903 26.3182C77.3447 26.3182 77.8198 25.9751 77.9782 25.4999H76.4208V25.0248H78.0574L78.5326 25.0512Z"
          fill="#0096D8"
        />
        <path
          d="M58.3385 26.7936V23.8899H58.7345V24.9194C58.9192 24.6818 59.1832 24.5498 59.4736 24.5498C60.0807 24.5498 60.6087 25.0778 60.6087 25.6849C60.6087 26.2921 60.1335 26.82 59.5264 26.82C59.2096 26.82 58.9192 26.688 58.7345 26.4505V26.7672L58.3385 26.7936ZM60.2391 25.7113C60.2391 25.289 59.9224 24.9458 59.5 24.9458C59.104 24.9458 58.7609 25.289 58.7609 25.7113C58.7609 26.1337 59.0776 26.4768 59.5 26.4768C59.896 26.4768 60.2391 26.1337 60.2391 25.7113Z"
          fill="#0096D8"
        />
        <path
          d="M61.295 27.5324L61.6118 26.7669L60.7407 24.6287H61.1894L61.823 26.3181L62.4829 24.6287H62.9317L61.7174 27.5324H61.295Z"
          fill="#0096D8"
        />
        <path
          d="M82.9146 9.1597V9.39728H82.4658V10.5588H82.2019V9.39728H81.7531V9.1597H82.9146ZM84.4193 10.5324L84.3665 9.71405C84.3665 9.60846 84.3665 9.47647 84.3665 9.31808H84.3401C84.3137 9.45007 84.2609 9.60846 84.2345 9.74044L83.9969 10.506H83.6801L83.4426 9.71405C83.4162 9.60846 83.3634 9.45007 83.337 9.31808H83.3106C83.3106 9.45007 83.3106 9.58206 83.3106 9.71405L83.2578 10.5324H82.9938L83.0994 9.1333H83.5217L83.7593 9.81964C83.7857 9.92523 83.8121 10.0308 83.8385 10.1628C83.8649 10.0308 83.9177 9.92523 83.9441 9.81964L84.1817 9.1333H84.5776L84.6832 10.5324H84.4193Z"
          fill="#0096D8"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_63_402"
          x1="43.7053"
          y1="10.7175"
          x2="41.0294"
          y2="10.7175"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#005899" />
          <stop offset="0.14" stopColor="#0066A7" stopOpacity="0.99" />
          <stop offset="0.46" stopColor="#0080C2" stopOpacity="0.97" />
          <stop offset="0.75" stopColor="#0090D2" stopOpacity="0.96" />
          <stop offset="1" stopColor="#0096D8" stopOpacity="0.96" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_63_402"
          x1="57.5304"
          y1="17.5544"
          x2="54.8545"
          y2="17.5544"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#005899" />
          <stop offset="0.14" stopColor="#0066A7" stopOpacity="0.99" />
          <stop offset="0.46" stopColor="#0080C2" stopOpacity="0.97" />
          <stop offset="0.75" stopColor="#0090D2" stopOpacity="0.96" />
          <stop offset="1" stopColor="#0096D8" stopOpacity="0.96" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_63_402"
          x1="79.2406"
          y1="17.7126"
          x2="76.5647"
          y2="17.7126"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#005899" />
          <stop offset="0.14" stopColor="#0066A7" stopOpacity="0.99" />
          <stop offset="0.46" stopColor="#0080C2" stopOpacity="0.97" />
          <stop offset="0.75" stopColor="#0090D2" stopOpacity="0.96" />
          <stop offset="1" stopColor="#0096D8" stopOpacity="0.96" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_63_402"
          x1="19.1497"
          y1="13.3834"
          x2="19.1497"
          y2="10.7076"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0096D8" />
          <stop offset="0.23" stopColor="#0091D3" />
          <stop offset="0.51" stopColor="#0082C3" />
          <stop offset="0.83" stopColor="#0069AA" />
          <stop offset="1" stopColor="#005899" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_63_402"
          x1="9.43537"
          y1="23.1931"
          x2="9.43537"
          y2="20.5173"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#51B8E5" />
          <stop offset="0.18" stopColor="#4CB3E1" />
          <stop offset="0.4" stopColor="#3FA3D5" />
          <stop offset="0.65" stopColor="#2A8AC0" />
          <stop offset="0.91" stopColor="#0C66A4" />
          <stop offset="1" stopColor="#005899" />
        </linearGradient>
        <clipPath id="clip0_63_402">
          <rect width="85" height="28.5621" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
